export const eventTypes = [
  { id: 'all', label: '全部' },
  { id: 'offline', label: '线下活动' },
  { id: 'online', label: '线上直播' },
  { id: 'collab', label: '合作联动' },
  { id: 'fan', label: '粉丝活动' },
];

export const events = [
  {
    id: 'e1',
    type: 'offline',
    typeLabel: '线下活动',
    period: '近期',
    title: '线下见面活动（整理条目）',
    summary: '以见面与互动为主的线下活动方向，通常需要提前报名并留意名额与场次安排。',
    meta: '参与方式：提前报名 · 名额有限',
  },
  {
    id: 'e2',
    type: 'online',
    typeLabel: '线上直播',
    period: '本季',
    title: '线上直播企划（整理条目）',
    summary: '线上直播类企划的公开方向，一般会提前公布时段，观看门槛较低，适合异地读者。',
    meta: '参与方式：按时段在线观看',
  },
  {
    id: 'e3',
    type: 'collab',
    typeLabel: '合作联动',
    period: '阶段',
    title: '品牌联名企划（整理条目）',
    summary: '与品牌或平台合作的联动方向，内容通常包含限定周边与合作影像，需关注发布渠道。',
    meta: '参与方式：关注官方渠道发布',
  },
  {
    id: 'e4',
    type: 'fan',
    typeLabel: '粉丝活动',
    period: '阶段性',
    title: '粉丝应援企划（整理条目）',
    summary: '面向长期关注者的应援类方向，形式多样，报名与参与细则以主办方公布为准。',
    meta: '参与方式：按主办方规则报名',
  },
  {
    id: 'e5',
    type: 'offline',
    typeLabel: '线下活动',
    period: '阶段性',
    title: '主题展陈活动（整理条目）',
    summary: '以主题展陈或快闪形式呈现的方向，适合想现场感受氛围的读者提前规划行程。',
    meta: '参与方式：现场参观 · 留意开放时间',
  },
  {
    id: 'e6',
    type: 'online',
    typeLabel: '线上直播',
    period: '持续',
    title: '定期互动直播（整理条目）',
    summary: '相对规律的线上互动方向，内容偏日常分享，时间以平台公告为准。',
    meta: '参与方式：按时段在线观看',
  },
];